<div class="p-6">
  <intelishs-page-header title="Dashboard" subtitle="Bienvenido a SINAY - Herramientas Generales" />

  <intelishs-section-header title="Listado de ejemplo" />

  <intelishs-data-table
    [data]="data()"
    [columns]="columns"
    [loading]="loading()"
    [pageSize]="10"
    searchPlaceholder="Buscar por nombre o estatus..."
    [showAddButton]="true"
    (add)="onAdd()"
  >
    <ng-template intelishsCellTemplate="acciones" let-row>
      <intelishs-table-actions [row]="row" [actions]="actions" (action)="onAction($event, row)" />
    </ng-template>
  </intelishs-data-table>
</div>
